<!-- DEX — Decentralized Exchange Frontend (Premium Futuristic Redesign) -->
<div
  class="min-h-screen flex flex-col bg-bg-primary text-text-body font-sans relative overflow-hidden selection:bg-gold/30 selection:text-white">

  <!-- Toast overlay notifications -->
  <app-toast></app-toast>

  <!-- Sticky header navigation bar -->
  @if (!hideNavbarFooter) {
    <app-navbar></app-navbar>
  }

  <!-- ═══════════════ MAIN CONTENT ACCORDING TO SELECTED NAV LINK ═══════════════ -->
  <main class="flex-1 flex flex-col w-full">
    <router-outlet></router-outlet>
  </main>

  <!-- Footer link listings -->
  @if (!hideNavbarFooter) {
    <app-footer></app-footer>
  }

  <!-- Popups / Modal dialogs -->
  <app-token-modal></app-token-modal>
  <app-staking-modal></app-staking-modal>
  <app-launchpad-modal></app-launchpad-modal>

</div>